import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EventReviewTrack from './EventReviewTrack';
import ApprovalHub from './ApprovalHub/ApprovalHub';
import './RequestEventFormTab.scss';
import { useSelector } from 'react-redux';

const RequestEventFormTab = () => {
  const params = useParams();
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));
  const { user_type } = userDetails;
  const [eventMode, setEventMode] = useState('add');

  useEffect(() => {
    if (params?.eventType === 'edit-event' && params?.eventId) {
      setEventMode('edit');
    } else if (params?.eventType === 'view-event' && params?.eventId) {
      setEventMode('view');
    } else {
      setEventMode('add');
    }
  }, [params]);

  const isEditMode = eventMode === 'edit';
  const isViewMode = eventMode === 'view';


  return (
    <>
      <div id="event-form-tab-container">
        <ApprovalHub isViewMode={isViewMode} isEditMode={isEditMode} user_type={user_type} />
      </div>

      {(isViewMode || (['0', '1'].includes(user_type) && isEditMode)) && (
        <div className="cmt-5">
          <EventReviewTrack />
        </div>
      )}
    </>
  );
};

export default RequestEventFormTab;
